import type { RouteObject } from "react-router";
import DashboardPage from "@/src/dashboard/pages/dashboard-page";

export const dashboardRoutes: RouteObject[] = [{ path: "/stats", element: <DashboardPage /> }];
